// #ux-redesign-start: shim que redirige /admin/settings → /admin/account?tab=preferences
// Profile + Settings se fusionaron en /admin/account. Mantenemos esta ruta para
// que el middleware (password_expired → /settings) y bookmarks externos sigan
// funcionando; el Account internamente fuerza tab=security cuando expired.
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

const Settings = () => {
  const password_expired = useSelector((state) => state.userReducer.password_expired);
  const tab = password_expired ? 'security' : 'preferences';
  return <Redirect to={`/admin/account?tab=${tab}`} />;
};

export default Settings;
// #ux-redesign-end
